import React from 'react';
import './index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import DueAmount from '../due-amount';
import { format } from 'date-fns';

function DataTable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='datatable border rounded h-auto'>
      <table className='table mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 1 ? 'text-start bg-table-head' : index === columns.length - 1 ? 'text-end bg-table-head' : 'text-center bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index} className='border-top'>
                      <td className='align-middle text-center'>{format(new Date(tb_items.bookingDate && tb_items.bookingDate.seconds * 1000), "dd-MM-yyyy")}</td>
                      <td
                        className="align-middle cursor-pointer text-primary"
                        onClick={() => navigate('details', { state: { ...tb_items } })}
                      >
                        {tb_items.id}
                      </td>
                      <td className="align-middle text-center">{tb_items.partyDetails.partyName}</td>
                      <td className="align-middle text-center">{tb_items.projectDetails.propName}</td>
                      <td className="align-middle text-center">{tb_items.projectDetails.bookedUnit.unitName}</td>
                      <td className="align-middle text-center">{tb_items.projectDetails.propCity}, {tb_items.projectDetails.propState}</td>
                      <td className="align-middle text-end">
                        <DueAmount bookingID={tb_items.id} />
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default DataTable;